import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  content: {
    padding: '0 52px 24px 52px',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  generateWrap: {
    marginTop: theme.spacing(2.5),
  },
  documentViewWrapper: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  selectButtonWrapper: {
    paddingLeft: '2%',
    marginBottom: '20px',
  },
}));
